import React from 'react';
import SidebarComponent from './SidebarComponent';
import PageHeader from './PageHeader';

const SanyolWtSpecilityChemicals: React.FC = () => {
    return (
        <>

            <PageHeader customClass='bg-breadcrumb-sanyola' title="SANYOL® WT Specialty Chemicals" />


            <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
                style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
                <div className="container">
                    <div className="row g-5">

                        <div className="col-lg-8">
                            <div className="row g-3 mb-5">
                                <div className="col-md-6">
                                    <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                                </div>
                                <div className="col-md-6">
                                    <img className="img-fluid" src="img/industrial-4.jpg" alt="" />
                                </div>
                            </div>
                            <h1 className="mb-4">SANYOL® WT Specialty Chemicals</h1>
                            <p>Our in-house brand, SANYOL® WT, offers a complete range of specialty chemicals for water treatment applications. These include scale inhibitors, corrosion preventives, biocides, and pH adjusters suitable for boiler systems, cooling towers, RO units, and effluent treatment.</p>

                            <h3 className="mb-4">Applications:</h3>
                            <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Boiler water treatment</p>
                            <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Cooling tower chemistry</p>
                            <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Antiscalants for RO membranes and cleaning chemicals</p>
                            <p><i className="fa fa-hand-holding-water text-primary me-2"></i>ETP/STP coagulants, flocculants</p>
                            <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Descalants</p>
                            <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Multi-effect Evaporator (MEE) Cleaning chemicals</p>
                            <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Solar Panel Cleaning Chemicals</p>

                            <h3 className="mb-4">Value-Added Benefits:</h3>
                            <p><i className="fa fa-project-diagram text-primary me-2"></i>Industry-proven formulations</p>
                            <p><i className="fa fa-project-diagram text-primary me-2"></i>Consistent quality and performance</p>
                            <p><i className="fa fa-project-diagram text-primary me-2"></i>Customized formulations for client-specific needs</p>
                            <p><i className="fa fa-project-diagram text-primary me-2"></i>On-site jar testing and performance benchmarking</p>
                            <p><i className="fa fa-project-diagram text-primary me-2"></i>Lower lifecycle cost through optimized dosing</p>
                            <p><i className="fa fa-project-diagram text-primary me-2"></i>Inventory planning and delivery support</p>
                            <p className="mb-5">Our SANYOL® WT specialty chemicals are formulated with cutting-edge technology to ensure optimal performance across diverse industrial applications, providing reliable solutions that enhance system efficiency and extend equipment life.</p>
                        </div>

                        <div className="col-lg-4">
                            <SidebarComponent />
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default SanyolWtSpecilityChemicals;
